import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {PageSaveButton,TableCheckBox,CustomTableRow,AddNewButtonLayout,
    DialogSaveButton} from '../../../common/Global/globalStyles.style';
import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,
    removeHtmlTags,isEmptyArray, getStatusSpan,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdown';
import {Accordion, Button, Card, Modal} from 'react-bootstrap';
import FilterDropDown from "../../../common/DropdownMenus/FilterDropdown";
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();

const activeStatus="Active";
const resourceDropdownPlaceholder="Select Resource";

class AddTaskAndResource extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            apiSearchKey:"",
            searchkey:"",
            currentPageNo: 1,
            showLoader:false,
            resultSize:Constants.RESULT_SIZE,
            totalCount:0,
            datalist:[],
            resultSizePlaceholder:Constants.RESULT_SIZE,
            status:activeStatus,

            users:[],
            functionMap:[],
            functionId:this.props.functionId,

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            // addErrors:{},
            showAssignResourcesDialogFlag:false,
            resourceDropdownPlaceholder:"Select Resource",

            filterDataList: [],
            FilterDropDownArr: [],
            FilterPlaceholder: "All",

            assigneResourcesFilterDropDownArr :[],
            assigneResourcesFilterDataList:[],
            assignResourcesPlaceholder:"All",
            activeKey: null,
            activeAssignResourceKey: null
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getInitData();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props)){
            this.setState({
                componentDidMountFlag:false,
                apiSearchKey:"",
                searchkey:"",
                currentPageNo: 1,
                showLoader:false,
                resultSize:Constants.RESULT_SIZE,
                totalCount:0,
                datalist:[],
                resultSizePlaceholder:Constants.RESULT_SIZE,
                status:activeStatus,

                users:[],
                functionMap:[],
                functionId:this.props.functionId,

                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",

                // addErrors:{},
                showProcessFunctionsDialog:false,
                resourceDropdownPlaceholder:"Select Resource",
            },()=>{
                this.getInitData();
            })
            
        }
    }

    handleShowOtherMasterDialog = () => {
        this.setState({
            showAssignResourcesDialogFlag:true,
        })
    }

    resourceDropdownClick = (resource) => {
        let newDataList = {};
        let resourceCount = 0;
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isResourceTaskSelected){
                    item.addedResourceToAssignment = true;
                    item.resourceName = resource.userName;
                    item.resourceId = resource.userId;
                    item.resourceDesignation = resource.designation;
                    item.resourcefullName = resource.fullName;
                }
                return item;
            })
            newValue.isFuncSelectedInResources = false;
            newTaskList = value.taskList.map(item=>{
                item.isResourceTaskSelected = false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        if(resourceCount>0){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:`${resourceCount} tasks have been allocated to ${resource.fullName}`,
            })
        }
        this.setState({
            datalist:newDataList,
            resourceCount:resourceCount
        })
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onCancelClick = () => {
        this.props.onClickBackBtnFromAddTasks();
    }

    //No need of return value since the array itself is passed and updated.
    addParentIdandHasChildrenFlag = (tempArr, functionId, parentFunctionId, parentFunctionBreadCrumb) => {
        tempArr[functionId].parentFunctionId = parentFunctionId;
        let breadCrumb = "";
        if(isEmptyVariable(parentFunctionBreadCrumb)){
            breadCrumb = tempArr[functionId].functionName;
            tempArr[functionId].breadCrumb = breadCrumb;
        }else{
            breadCrumb = parentFunctionBreadCrumb + " > " + tempArr[functionId].functionName;
            tempArr[functionId].breadCrumb = breadCrumb;
        }

        if(!isEmptyArray(tempArr[functionId].children)){
            tempArr[functionId].hasChildren = true;

            tempArr[functionId].children.map(childNode => {
                this.addParentIdandHasChildrenFlag(tempArr,childNode.functionId,functionId,breadCrumb);
            });
        }else{
            tempArr[functionId].hasChildren = false;
        }
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    handleSelectionTasks = (e) => {
        e.stopPropagation();
        this.setState({
            showLoader:true
        })
        // alert(e.target.name)

        let isChecked = e.target.checked;
        let indexAndFunctionId = e.target.name;
        let iapArr = indexAndFunctionId.split(":-:")
        let index = iapArr[0];
        let functionId = iapArr[1];
        let list = this.state.datalist;
        
        list[functionId].taskList[index].isSelected = isChecked;

        //check whether all the tasks with in func are selected
        let atleastOneNotSelected = list[functionId].taskList.some(item => !item.isSelected)
        list[functionId].isFuncSelected = !atleastOneNotSelected;

        this.setState({
            datalist:list,
            showLoader:false
        });
    }

    handleSelectionFunctionTasksInResourcesDialog = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let functionId = e.target.name;
        let list = this.state.datalist;

        list[functionId].isFuncSelectedInResources = isChecked;

        // also select added tasks only
        let newTasklist = list[functionId].taskList.map(item=>{
            item.isResourceTaskSelected = item.added ? isChecked : false;
            return item;
        })
        list[functionId].taskList = newTasklist;

        this.setState({
            datalist:list
        });
    }

    handleSelectionTaskInResourcesDialog = (e) => {
        e.stopPropagation();

        let isChecked = e.target.checked;
        let indexAndFunctionId = e.target.name;
        let iapArr = indexAndFunctionId.split(":-:")
        let index = iapArr[0];
        let functionId = iapArr[1];
        let list = this.state.datalist;

        list[functionId].taskList[index].isResourceTaskSelected = isChecked;
        
        //check whether all the added tasks within func are selected
        let atleastOneNotSelected = list[functionId].taskList.some(item => item.added && !item.isResourceTaskSelected)
        list[functionId].isFuncSelectedInResources = !atleastOneNotSelected;


        this.setState({
            datalist:list,
            showLoader:false
        });
    }

    onClickAddToAssignment = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isSelected){
                    item.added = true;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })

    }

    onClickRemoveFromAssignment = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isSelected){
                    item.added = false;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    selectAll = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isFuncSelected = true;
            let newTaskList = value.taskList.map(item=>{
                item.isSelected = true;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    selectAllTaskResourceDialog = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isFuncSelectedInResources = true;
            //when user "selects all" in resource dialog, we should select all the tasks
            //that are added to the assignment
            let newTaskList = value.taskList.map(item=>{
                item.isResourceTaskSelected = item.added?true:false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    unSelectAll = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isFuncSelected = false;
            let newTaskList = value.taskList.map(item=>{
                item.isSelected = false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    unSelectAllTaskResourceDialog = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isFuncSelectedInResources = false;
            let newTaskList = value.taskList.map(item=>{
                item.isResourceTaskSelected = false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    getRootLevelFunctions = (functionMapTemp) => {
        let rootFunctionArr = [];
        Object.values(functionMapTemp).map((item)=>{
            if(item.level === 0){
                rootFunctionArr.push(item);
            }
        })
        return rootFunctionArr;
    }

    assignResourcesDialogClose = () => {
        this.unSelectAllTaskResourceDialog();
        this.setState({
            datalist:this.state.oldDataList,
            showAssignResourcesDialogFlag:false,
            activeAssignResourceKey:null
        })
    }

    handleSelectionFunctionTasks = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let functionId = e.target.name;
        let list = this.state.datalist;

        list[functionId].isFuncSelected = isChecked;

        // also select all the tasks
        let newTasklist = list[functionId].taskList.map(item=>{
            item.isSelected = isChecked
            return item;
        })
        list[functionId].taskList = newTasklist;
        this.setState({
            datalist:list
        });
    }

    convertFilterArrayToMap = (arr) => {
        let map = {};
        arr.forEach(item => {
            map[item.functionId] = item;
        });
        return map;
    }

    getOrderedLeafProcesses = () => {
        const functionMap = this.state.functionMap;
        if (!functionMap || Object.keys(functionMap).length === 0) {
            return [];
        }
        // choose data source
        const sourceList = isEmptyArray(this.state.filterDataList)
            ? this.state.datalist
            : this.state.filterDataList;
        // convert array to map if needed
        let sourceMap = {};
        if (Array.isArray(sourceList)) {
            sourceList.forEach(item => {
                sourceMap[item.functionId] = item;
            });
        } else {
            sourceMap = sourceList || {};
        }

        const ordered = [];
        const traverse = (functionId) => {
            const node = functionMap[functionId];
            if (!node) return;
            // if has children → go deeper
            if (node.children && node.children.length > 0) {
                node.children.forEach(child => {
                    traverse(child.functionId);
                });
            } else {
                // leaf node
                if (sourceMap[functionId]) {
                    ordered.push(sourceMap[functionId]);
                }
            }
        };

        // get root level processes automatically
        const roots = this.getRootLevelProcesses(functionMap);
        roots.forEach(root => {
            traverse(root.functionId);
        });

        return ordered;
    }

    getRootLevelProcesses = (functionMap) => {
        let rootArr = [];
        Object.values(functionMap).forEach(node => {
            if (!node.parentFunctionId || node.parentFunctionId === node.functionId) {
                rootArr.push(node);
            }
        });
        return rootArr;
    };
    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });

        Promise.all([
            fetch(Constants.GetFunctionsSubtree,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    departmentId:this.props.departmentId
                })
            }),
            fetch(Constants.GetAssignTaskMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                })
            }),
            fetch(Constants.GetAssignedTasks,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                })
            })
        ])
        .then(([masterRes,generalRes,assignedTasksRes]) => { 
            return Promise.all([masterRes.json(),generalRes.json(),assignedTasksRes.json()]) 
        })
        .then(([masterRes,generalRes,assignedTasksRes]) => {
            let functionMapTemp = {};
            let datalistTemp = {};
            let users = [];
            let assignedTasksMap = {};

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                functionMapTemp = masterRes.result.functionMap;
                let rootLevelArr = this.getRootLevelFunctions(functionMapTemp)
                for(const [index,value] of rootLevelArr.entries()){
                    this.addParentIdandHasChildrenFlag(functionMapTemp,value.functionId,value.functionId,"");
                }
            }else{
            }

            if(handleTokenExpiry(assignedTasksRes.responseCode)) return;
            else if(assignedTasksRes.responseCode === Constants.CODE_SUCCESS){
                let assignedTasks = assignedTasksRes.data.assignedTasks;

                //create a mapping with task id and leaf node id as key, it helps to search the task
                assignedTasks.forEach(item=>{
                    assignedTasksMap[item.taskId+":-:"+item.leafNodeId] = item;
                })
            }else{
            }

            if(handleTokenExpiry(generalRes.responseCode)) return;
            else if(generalRes.responseCode === Constants.CODE_SUCCESS){
                let datalistTempArr = generalRes.data.taskList;//list of process and task
                let assignmentReviewMatrix = generalRes.data.assignmentReviewMatrix;
                let assignmentMemberMatrix = generalRes.data.assignmentMemberMatrix;
                //need to get only active users
                let activeMembers = assignmentMemberMatrix.filter(item=> item.status === "Active");
                let activeReviewers = assignmentReviewMatrix.filter(item=> item.status === "Active");

                users = [...activeMembers,...activeReviewers]
                datalistTemp = {};

                datalistTempArr.map((item)=>{
                    //add only leaf level nodes
                    if(!functionMapTemp[item.functionId].hasChildren){
                        //Now lets add the already assigned tasks
                        let updatedTaskList = [];
                        item.taskList.forEach(task=>{
                            // check if the taskId is there in task map, if yes then add the user info

                            // since leaf node id is functionid, lets search the map
                            if(!isEmptyVariable(assignedTasksMap[task.taskId+":-:"+item.functionId])){
                                const key = task.taskId+":-:"+item.functionId;
                                task.added = true;
                                task.assigmentTaskStatus = assignedTasksMap[key].status;
                                task.assignmentTaskId = assignedTasksMap[key].assignmentTaskId;
                                task.completionStatus = assignedTasksMap[key].completionStatus;
                                
                                task.resourceName = assignedTasksMap[key].userName;
                                task.resourceId = assignedTasksMap[key].userId;
                                task.resourceDesignation = assignedTasksMap[key].designation;
                                task.resourcefullName = assignedTasksMap[key].userName+"("+assignedTasksMap[key].designation+")";
                            }

                            updatedTaskList.push(task);
                        })
                        item.taskList = updatedTaskList;
                        
                        datalistTemp[item.functionId] = item;
                        datalistTemp[item.functionId].currentPageNo = 1; //set the current page no as 1 for all the individual task lists
                    }
                })
            }else{
            }

            // console.log(JSON.stringify(datalistTemp));
            let tempFilterArray = [
                {
                  label: "All",
                  isSelected: true,
                },
              ];
              Object.values(datalistTemp).map((functionObj)=>{
                tempFilterArray.push({
                    label:functionMapTemp[functionObj.functionId].functionName,
                    isSelected:false
                })
              })
            
            
            this.setState({
                componentDidMountFlag:true,
                showLoader:false,

                functionMap:functionMapTemp,
                datalist:datalistTemp,
                users:users,
                FilterDropDownArr:tempFilterArray,
            })
        })
    }

    onClickNextButton = () => {

        this.setState({
            showLoader:true
        })

        let isError = true;
        // let formErr = {};
        // formErr.assignTaskErr = "Please add atleast one task to the assignment"

        Object.values(this.state.datalist).map(functionObj=>{
            functionObj.taskList.map(item=>{
                if(item.added){
                    isError = false;
                    // formErr.assignTaskErr = "";
                }
            })
        })

        let tempFilterArray = [
            {
              label: "All",
              isSelected: true,
            },
        ];

        Object.values(this.state.datalist).map((processObj)=>{
            let  showTasks=(processObj.taskList).some((item) =>item.added===true)
            if(showTasks){
                tempFilterArray.push({
                    label:this.state.functionMap[processObj.functionId].functionName,
                    isSelected:false
                })
            }
        })
        let oldDataList = JSON.parse(JSON.stringify(this.state.datalist));
        //now do the validation
        if(isError){
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please add atleast one task to the assignment"
            });
        }else{
            this.setState({
                showAssignResourcesDialogFlag:true,
                showLoader:false,
                oldDataList:oldDataList,
                assigneResourcesFilterDataList:[],
                assigneResourcesFilterDropDownArr:tempFilterArray,
                assignResourcesPlaceholder:"All"
            })
        }
    }

    onClickAddResourceToAssignment = () => {
        let isError = false;
        // let otherMasterFormErr = "";
        Object.values(this.state.datalist).forEach(functionObj=>{
            functionObj.taskList.forEach(item=>{
                if(item.added && isEmptyVariable(item.resourceId)){
                    isError = true;
                    // otherMasterFormErr = "Please add resource to all the tasks";
                }else{
                    
                }
            })
        })

        if(isError){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please add resource to all the tasks"
            })
        }else{
            //now parse the array
            let assignmentTasks = []
            Object.values(this.state.datalist).forEach(functionObj=>{
                functionObj.taskList.forEach(item=>{
                    if(item.added && !isEmptyVariable(item.resourceId)){
                        let obj = {
                            taskId:item.taskId,
                            userId:item.resourceId,
                            userName:item.resourceName,
                            designation:item.resourceDesignation,
                            leafNodeId:functionObj.functionId,
                        }

                        //dont add duplicate 
                        // let addToArr = true;
                        // assignmentTasks.forEach(taskObj => {
                        //     if(taskObj.taskId === item.taskId){
                        //         addToArr = false;
                        //     }
                        // })

                        // if(addToArr){
                        //     assignmentTasks.push(obj);
                        // }

                        if(!isEmptyVariable(item.assignmentTaskId)){
                            obj.assignmentTaskId = item.assignmentTaskId;
                        }
                        
                        assignmentTasks.push(obj);
                    }
                })
            })

            //call the fetch function

            fetch(Constants.AssignTasks,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentTasks:JSON.stringify(assignmentTasks),
                    assignmentId:this.props.assignmentId
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.props.onClickBackBtnFromAddTasks(true);
                }else{
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });

        }
    }
    /*******************API CALLS END HERE*******************/

    filterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.FilterDropDownArr;
        if(selectedItem.label==="All")
        {
            this.setState({
                filterDataList:[],
            })
        }
        else{

            Object.values(this.state.datalist).map((item)=>{
                if(selectedItem.label === item.functionName)
                {
                    tempFilterDataList.push(
                        item
                    )
                }
            })

        }
        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
            item.isSelected = true;
            } else {
            item.isSelected = false;
            }
          });

        this.setState({
            filterDataList:tempFilterDataList,
            FilterDropDownArr:tempFilterDataArray,
            FilterPlaceholder:selectedItem.label

        })

    }

    assigneResourceFilterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.assigneResourcesFilterDropDownArr;
        if(selectedItem.label==="All")
        {
            this.setState({
                filterDataList:[],
            })
        }
        else{

            Object.values(this.state.datalist).map((item)=>{
                if(selectedItem.label === item.functionName)
                {
                    tempFilterDataList.push(
                        item
                    )
                }
            })

        }
        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
            item.isSelected = true;
            } else {
            item.isSelected = false;
            }
          });

        this.setState({
            assigneResourcesFilterDataList:tempFilterDataList,
            assigneResourcesFilterDropDownArr:tempFilterDataArray,
            assignResourcesPlaceholder:selectedItem.label

        })

    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    handleAccordionToggle = (eventKey) => {
        if (this.state.activeKey === eventKey) {
            this.setState({ activeKey: null });
        } else {
            this.setState({ activeKey: eventKey });
        }
    }

    handleAccordionToggleAssignResource = (eventKey) => {
        if (this.state.activeAssignResourceKey === eventKey) {
            this.setState({ activeAssignResourceKey: null });
        } else {
            this.setState({ activeAssignResourceKey: eventKey });
        }
    }
    render() {
        const orderedList = this.getOrderedLeafProcesses();
        return(
            <div>
                {
                    this.state.showLoader &&
                    <div class="loader"></div>
                }
                {
                    // Need to check component did mount flag, other wise until api is called,
                    // it shows no items found layout.
                    this.state.componentDidMountFlag &&
                    <div className="body-wrapper">
                        <div className="secondary-bar-wrapper">
                            <div className="flex-center-layout secondary-top-bar m-t-0">
                                <div className="back-btn-layout" onClick={this.props.onClickBackBtnFromAddTasks}>
                                    <span class="material-icons-outlined">arrow_back_ios</span>
                                </div>
                                <h6>{this.props.referenceNo}</h6>
                            </div>
                            <div className="flex-center-layout">
                                <div style={{ marginRight: 10 }}>
                                    <FilterDropDown
                                        placeholder={this.state.FilterPlaceholder}
                                        dropdownArr={this.state.FilterDropDownArr}
                                        onDropDownItemClick={this.filterDropDownOnClick}
                                        themeSettings={themeSettings}
                                        name={"label"}
                                        dropdownWidth="200px"
                                    />
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.unSelectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box_outline_blank
                                        </span>
                                        <p>Unselect All</p>
                                    </a>
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.selectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box
                                        </span>
                                        <p>Select All</p>
                                    </a>
                                </div>
                                <AddNewButtonLayout themeSettings={themeSettings}
                                style={{marginRight:5}}>
                                    <a onClick={this.onClickRemoveFromAssignment} href="javascript:void(0);">
                                        <span className="material-icons">remove_circle_outline</span>
                                        <p>Remove</p>
                                    </a>
                                </AddNewButtonLayout>

                                <AddNewButtonLayout themeSettings={themeSettings}>
                                    <a onClick={this.onClickAddToAssignment} href="javascript:void(0);">
                                        <span className="material-icons">add_circle</span>
                                        <p>Add to Assignment</p>
                                    </a>
                                </AddNewButtonLayout>

                                <AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:5}}>
                                    <a onClick={this.onClickNextButton} href="javascript:void(0);">
                                        {/* <span className="material-icons">add_circle</span> */}
                                        <p>Next</p>
                                        <span class="material-icons-outlined">arrow_forward_ios</span>
                                    </a>
                                </AddNewButtonLayout>
                                
                            </div>
                        </div>
                        <div className="assign-tasks-layout accordion-layout">
                            {
                                // Object.values(isEmptyArray(this.state.filterDataList)?this.state.datalist:this.state.filterDataList)
                                orderedList.map((functionObj,index)=>{
                                    let className;
                                    if (index === 0) {
                                        className = 'card-radius'; // CSS for the first item
                                    } else if (index === (Object.values(isEmptyArray(this.state.filterDataList)?
                                    this.state.datalist:this.state.filterDataList).length - 1)) {
                                        className = 'card-last'; // CSS for the last item
                                    } else {
                                        className = 'card-middle'; // CSS for all other items
                                    }
                                    return <div className="process-task-list">
                                        <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeKey}>
                                            <Card className={className}> 
                                                <Card.Header>
                                                    <Accordion.Toggle
                                                        as={Button}
                                                        variant="link"
                                                        eventKey={functionObj.functionId}
                                                        onClick={() => this.handleAccordionToggle(functionObj.functionId)}
                                                    >
                                                        <div className='row align-items-center'>
                                                            <TableCheckBox onClick={this.handleStopPropagation}
                                                                themeSettings={themeSettings}>
                                                                <input 
                                                                    type="checkbox"
                                                                    name={functionObj.functionId}
                                                                    id={functionObj.functionId}
                                                                    onChange={this.handleSelectionFunctionTasks}
                                                                    checked={functionObj.isFuncSelected?true:false}
                                                                />
                                                                <label for={functionObj.functionId} 
                                                                style={{marginLeft:-3}}></label>
                                                            </TableCheckBox>
                                                            <h6 className='col-md-6 text-left'>{this.state.functionMap[functionObj.functionId].breadCrumb}</h6>
                                                                <h6 className='col-md-2 text-left'>{"Total Task: "+(functionObj.count || 0)}</h6>
                                                                <h6 className='col-md-3 text-center'>{"Added to Assignment: "+functionObj.taskList.filter(item => item.added == true).length}</h6>
                                                        </div>
                                                    </Accordion.Toggle>
                                                </Card.Header> 
                                                <Accordion.Collapse eventKey={functionObj.functionId}>
                                                    <Card.Body>
                                                    {
                                                        isEmptyArray(functionObj.taskList) &&
                                                        <div class="no-items-layout">
                                                            <div class="no-items-card" style={{padding:"10px"}}>
                                                                <h6 style={{margin:0}}>
                                                                {
                                                                    isEmptyVariable(this.state.apiSearchKey)?
                                                                    Constants.NO_RECORDS_WARNING
                                                                    :
                                                                    Constants.EMPTY_SEARCH_WARNING
                                                                }
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        !isEmptyArray(functionObj.taskList) &&
                                                        <div className="common-tab-bg">
                                                            <div class="common-table" style={{width: "100%", borderRadius: "4px"}}>
                                                                <div className="table-custom-layout">
                                                                    <div className="table-custom-header">
                                                                        <div className="table-custom-header-row">
                                                                            <p style={{width:"5%"}}>
                                                                                
                                                                            </p>
                                                                            <p style={{width:"5%",justifyContent:"center"}}>No</p>
                                                                            <p style={{width:"52%"}}>Task</p>
                                                                            <p style={{width:"30%"}}>Resource</p>
                                                                            <p style={{width:"8%"}}>Added</p>
                                                                            
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div className="table-custom-body">
                                                                    {
                                                                        !isEmptyArray(functionObj.taskList) && 
                                                                        functionObj.taskList.map((item,idx) => {
                                                                            let spanObj = getStatusSpan(item.assigmentTaskStatus,themeSettings);

                                                                            return <CustomTableRow themeSettings={themeSettings}
                                                                            className={item.disabled?"row-disable":""}>
                                                                                <div className="table-cell" style={{width:"5%"}}>
                                                                                    <TableCheckBox onClick={this.handleStopPropagation}
                                                                                        themeSettings={themeSettings}>
                                                                                        <input 
                                                                                            type="checkbox"
                                                                                            name={idx+":-:"+functionObj.functionId}
                                                                                            id={idx+":-:"+functionObj.functionId+":-:"+item.taskId}
                                                                                            onChange={this.handleSelectionTasks}
                                                                                            disabled={item.disabled}
                                                                                            checked={item.isSelected?true:false}
                                                                                        />
                                                                                        <label for={idx+":-:"+functionObj.functionId+":-:"+item.taskId} 
                                                                                        style={{marginLeft:6}}></label>
                                                                                    </TableCheckBox>
                                                                                </div>
                                                                                <p style={{width:"5%",justifyContent:"center"}}>{(idx+1)}</p>
                                                                                <p style={{width:"52%"}}>
                                                                                    {/* {removeHtmlTags(item.task)} */}
                                                                                    <div className='task-dangerouslysethtml' dangerouslySetInnerHTML={{__html: item.task}} />
                                                                                    {
                                                                                        item.completionStatus==="Completed" &&
                                                                                        <span style={{marginLeft:6}}className="material-icons">done_all</span>
                                                                                    }
                                                                                    {
                                                                                        !isEmptyVariable(spanObj.spanText) &&
                                                                                        <span style={spanObj.spanStyle} className="span-tag">
                                                                                            {spanObj.spanText}
                                                                                        </span>
                                                                                    }
                                                                                </p>
                                                                                
                                                                                <p style={{width:"30%"}}>{item.added && !isEmptyVariable(item.resourcefullName)?item.resourcefullName:""}</p>
                                                                                <p style={{width:"8%"}}>
                                                                                    {
                                                                                        item.added &&
                                                                                        <span class="material-icons"
                                                                                        style={{color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`}}>check_circle</span>
                                                                                    }
                                                                                </p>
                                                                                
                                                                            </CustomTableRow>
                                                                        })
                                                                    }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    </div>
                                })
                            }
                            {/* {
                                !isEmptyVariable(this.state.addErrors['assignTaskErr']) &&
                                <span class="cm-error">{this.state.addErrors['assignTaskErr']}</span>
                            } */}
                            {/* <div className="row custom-row">
                                <div className="col-md-12 custom-col">
                                    <div className="common-close-save">
                                        <div className="common-close-save-col">
                                            <button onClick={this.onCancelClick} type="button" className="common-close">Cancel</button>
                                            <PageSaveButton 
                                            themeSettings = {themeSettings}
                                            onClick={this.onClickNextButton} type="button">Next</PageSaveButton>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                }

                {/* Add Resources Dialog */}
                <AlertDialog
					showAlertDialog={this.state.showAlertDialogInfo}
					handleAlertDialogClose={this.handleAlertDialogCloseInfo}
					type={Constants.ALERT_TYPE_ALERT}
					alertDialogMessage={this.state.alertDialogMessageInfo}
					proceedBtnClick={this.handleAlertDialogCloseInfo}
					proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
					themeSettings={themeSettings}
				/>
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.state.showAssignResourcesDialogFlag} 
                    backdrop="static">
                    <Modal.Header>
                        <h5>Assign Resources</h5>
                        <button 
                            onClick={this.assignResourcesDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                            <div className="body-wrapper">
                                <div className="search-addnew-bg" style={{marginTop:0}}>
                                    <div className="search-addnew">
                                        <div className="flex-center-layout">
                                            <div style={{ marginRight: 10 }}>
                                                <FilterDropDown
                                                    placeholder={this.state.assignResourcesPlaceholder}
                                                    dropdownArr={this.state.assigneResourcesFilterDropDownArr}
                                                    onDropDownItemClick={this.assigneResourceFilterDropDownOnClick}
                                                    themeSettings={themeSettings}
                                                    name={"label"}
                                                    dropdownWidth="200px"
                                                />
                                            </div>
                                            <div className="bordered-anchor"
                                            style={{marginRight:5}}>
                                                <a onClick={this.unSelectAllTaskResourceDialog} href="javascript:void(0);">
                                                    <span class="material-icons-outlined">
                                                    check_box_outline_blank
                                                    </span>
                                                    <p>Unselect All</p>
                                                </a>
                                            </div>
                                            <div className="bordered-anchor"
                                            style={{marginRight:5}}>
                                                <a onClick={this.selectAllTaskResourceDialog} href="javascript:void(0);">
                                                    <span class="material-icons-outlined">
                                                    check_box
                                                    </span>
                                                    <p>Select All</p>
                                                </a>
                                            </div>
                                            <div style={{width:"300px"}}>
                                                <RegularDropdown 
                                                    placeholder={this.state.resourceDropdownPlaceholder}
                                                    dropdownArr={this.state.users}
                                                    labelParam="fullName"
                                                    onDropDownItemClick={this.resourceDropdownClick}
                                                    defaultPlaceholderDropDown={resourceDropdownPlaceholder}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <DialogSaveButton  themeSettings={themeSettings} 
                                            onClick={this.onClickAddResourceToAssignment} type="button" 
                                            className="modal-save m-b-0">Assign</DialogSaveButton>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className = "assign-taskresource accordion-layout" style={{position:"relative"}}>
                                    { Object.values( isEmptyArray(this.state.assigneResourcesFilterDataList)?this.state.datalist:this.state.assigneResourcesFilterDataList)
                                    .filter(functionObj => functionObj.taskList.some((item) => item.added === true))
                                    .map((functionObj,index)=>{
                                        let showTasks =false;
                                        let className;
                                        if (index === 0) {
                                            className = 'card-radius'; // CSS for the first item
                                        } else if (index === ((Object.values(isEmptyArray(this.state.assigneResourcesFilterDataList)?
                                            this.state.datalist:this.state.assigneResourcesFilterDataList))
                                            .filter(functionObj => functionObj.taskList.some((item) => item.added===true))).length - 1) {
                                            className = 'card-last'; // CSS for the last item
                                        } else {
                                            className = 'card-middle'; // CSS for all other items
                                        }
                                        // showTasks=!!functionObj.taskList.find(({added}) =>added===true)
                                        showTasks=functionObj.taskList.some((item) =>item.added===true)
                                        if(showTasks){
                                            return <div className="process-task-list">
                                                <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeAssignResourceKey}>
                                                    <Card className={className}> 
                                                        <Card.Header>
                                                            <Accordion.Toggle
                                                                as={Button}
                                                                variant="link"
                                                                eventKey={functionObj.functionId}
                                                                onClick={() => this.handleAccordionToggleAssignResource(functionObj.functionId)}
                                                            >
                                                                <div className='row align-items-center'>
                                                                    <TableCheckBox
                                                                        themeSettings={themeSettings}>
                                                                        <input
                                                                            type="checkbox"
                                                                            name={functionObj.functionId}
                                                                            id={"RES"+functionObj.functionId}
                                                                            onChange={this.handleSelectionFunctionTasksInResourcesDialog}
                                                                            checked={functionObj.isFuncSelectedInResources?true:false}
                                                                        />
                                                                        <label for={"RES"+functionObj.functionId}
                                                                        style={{marginLeft:5}}></label>
                                                                    </TableCheckBox>
                                                                    <div className='d-flex flex-column ml-3' style={{flex:1}}>
                                                                        <h6 className='text-left'>{this.state.functionMap[functionObj.functionId].breadCrumb}</h6>
                                                                        <div className='d-flex mt-2' style={{gap:16}}>
                                                                            {
                                                                                functionObj.count > 0 &&
                                                                                <h6 className='text-left mb-0' style={{fontSize:13}}>{"Added Task: "+functionObj.taskList.filter(item => item.added == true).length}</h6>
                                                                            }
                                                                            <h6 className='text-left mb-0' style={{fontSize:13}}>{"Resource Assigned: "+functionObj.taskList.filter(taskItem => taskItem.added && !isEmptyVariable(taskItem.resourcefullName)).length}</h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Accordion.Toggle>
                                                        </Card.Header> 
                                                        <Accordion.Collapse eventKey={functionObj.functionId}>
                                                            <Card.Body>
                                                                {
                                                                    <div className="common-tab-bg">
                                                                        <div className="common-table" style={{width:"100%"}}>
                                                                            <table className="table">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="text-center" width={"8%"}></th>
                                                                                        <th className="text-center" width={"5%"}>No.</th>
                                                                                        <th width={"55%"}>Tasks</th>
                                                                                        <th width={"33%"}>User</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>

                                                                                {/* {
                                                                                    Object.values(this.state.datalist).map((functionObj,index)=>{
                                                                                        let i = 0;
                                                                                        return functionObj.taskList.map((item,idx) => { */}
                                                                                {
                                                                                    !isEmptyArray(functionObj.taskList) && 
                                                                                    functionObj.taskList
                                                                                    .map((item, idx) => ({ item, idx }))
                                                                                    .filter(({ item }) => item.added)
                                                                                    .map(({ item, idx: origIdx }, i) => {
                                                                                            return <tr>
                                                                                                <td>
                                                                                                    <TableCheckBox
                                                                                                        themeSettings={themeSettings}>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            name={origIdx+":-:"+functionObj.functionId}
                                                                                                            id={"RES"+origIdx+":-:"+functionObj.functionId+":-:"+item.taskId}
                                                                                                            onChange={this.handleSelectionTaskInResourcesDialog}
                                                                                                            checked={item.isResourceTaskSelected?true:false}
                                                                                                        />
                                                                                                        <label for={"RES"+origIdx+":-:"+functionObj.functionId+":-:"+item.taskId}
                                                                                                        style={{marginLeft:6}}></label>
                                                                                                    </TableCheckBox>
                                                                                                </td>
                                                                                                <td className="text-center">{i + 1}</td>
                                                                                                <td>
                                                                                                    <div className="flex-center-layout">
                                                                                                        {/* {removeHtmlTags(item.task)} */}
                                                                                                        <div className='task-dangerouslysethtml' dangerouslySetInnerHTML={{__html: item.task}} />
                                                                                                        {
                                                                                                            item.completionStatus==="Completed" &&
                                                                                                            <span style={{marginLeft:6,fontSize:18}}
                                                                                                            className="material-icons">done_all</span>
                                                                                                        }
                                                                                                        </div>
                                                                                                </td>
                                                                                                <td>{isEmptyVariable(item.resourcefullName)?"":item.resourcefullName}</td>
                                                                                            </tr>
                                                                                    })
                                                                                }
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                
                                                                }
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            </div>
                                        }
                                    })}
                                </div>
                            </div>
                            {/* {
                                !isEmptyVariable(this.state.otherMasterFormErr) &&
                                <span className="cm-error">{this.state.otherMasterFormErr}</span>
                            } */}
                            {/* <div className="modal-close-save m-t-15" style={{marginBottom:20}}>
                                <div className="close-save-col">
                                    <button onClick={this.assignResourcesDialogClose} type="button" 
                                    className="modal-close m-b-0">Cancel</button>
                                    <DialogSaveButton  themeSettings={themeSettings} 
                                    onClick={this.onClickAddResourceToAssignment} type="button" 
                                    className="modal-save m-b-0">Assign</DialogSaveButton>
                                </div>
                            </div> */}
                        </div>
                </Modal>
            </div>
        );
    }
}

export default AddTaskAndResource;